import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Label } from '@/components/ui/label'

interface ObjectFieldProps {
  field: FieldSchema
  value: any
  onChange: (value: any) => void
  onImageRequest: (path: string) => void
  path: string
  renderField: (
    field: FieldSchema,
    value: any,
    onChange: (val: any) => void,
    path: string
  ) => React.ReactNode
}

export const ObjectField = ({
  field,
  value,
  onChange,
  onImageRequest,
  path,
  renderField,
}: ObjectFieldProps) => {
  return (
    <div className="space-y-4 border p-4 rounded-xl bg-muted/5">
      {field.fields?.map((childField) => {
        if (childField.dependency) {
          const dependencyValue = value?.[childField.dependency.field]
          if (dependencyValue !== childField.dependency.value) {
            return null
          }
        }
        return (
          <div key={childField.key} className="space-y-2">
            <Label className="text-subtitle2 text-ink">
              {childField.label}
            </Label>
            {renderField(
              childField,
              value?.[childField.key],
              (newVal) => {
                onChange({ ...(value || {}), [childField.key]: newVal })
              },
              `${path ? path + '.' : ''}${childField.key}`
            )}
          </div>
        )
      })}
    </div>
  )
}
